const filterNodes = {
  quickShopModal: document.querySelector('quick-shop'),
  parent: document.getElementById('collectionFilters'),
  gridsContainer: document.getElementById('products-listing'),
  collectionBanner: document.querySelector('[data-collectionBanner]'),
  topBanners: document.querySelector('[data-top-banners]'),
  subCollectionLinks: Array.from(document.getElementsByClassName('subcollection-links')),
  openDrawerBtns: document.querySelectorAll('[data-openFilterDrawer]'),
  paginationParent: document.querySelector('[data-paginationParent]'),
  closeDrawer: document.querySelector('[data-closeDrawer]')
}

class CollectionFilters {
  constructor() {
    this.filterForm = filterNodes.parent.querySelector('form');

    filterNodes.parent.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE'){ filterNodes.closeDrawer.dispatchEvent(new Event('click')); }
    });

    this.debouncedOnSubmit = Utility.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    if(this.filterForm){
      this.filterForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
      this.filterForm.addEventListener('submit', this.debouncedOnSubmit.bind(this));
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }
    
    this.bindEvents();
    this.dynamicEleEvents();
    
    // Trigger 'Featured' sort on load
    this.triggerFeaturedSortOnLoad();
  }

  /**
   * bind dclick and keyup event to Cart Icons
   * bind keyUp event to Cart drawer component
   * bind Other inside element events
   *
  */
  bindEvents() {
    /** There are two open drawer buttons, one for Open filter drawer other for open sortby drawer **/
    if(filterNodes.openDrawerBtns.length > 0){
      filterNodes.openDrawerBtns.forEach(button => button.addEventListener('click', this.toggleFilterDrawer.bind(this)));
    }
    
    filterNodes.closeDrawer.addEventListener('click', this.toggleFilterDrawer.bind(this));

    let sortby_desktop = document.querySelectorAll('[data-sortByDesktop] .sortby_options');
    sortby_desktop.forEach(input => input.addEventListener('change', this.updateSortBy.bind(this)));
    

    let paginateByValues = document.querySelectorAll('[data-custom-pagination] [name="paginateBy"]');
    paginateByValues.forEach(input => input.addEventListener('change', this.paginateProductsBy.bind(this)));

    /** Only for horizontal filters - Close filters when clicked outside container **/
    const filterType = filterNodes.parent.dataset.filtertype;
    if(filterType == 'horizontal-filters'){
      document.body.addEventListener('click', (_event)=>{
        const openFilters = document.querySelectorAll('.filter__container.open');
        openFilters.forEach((target) => {
          target.querySelector('.tab_toggle').click();
        })
      });
  
      const filterContainers = document.querySelectorAll('.filter__container');
      filterContainers.forEach((target) => {
        target.addEventListener('click', (event)=>{
          event.stopPropagation();
        });
      });
    }
  }

  dynamicEleEvents() {
    /** Toggle each filter block container containing values for dropdown effect **/
    const toggleBtns = Array.from(filterNodes.parent.getElementsByClassName('tab_toggle'));
    toggleBtns.forEach(button => button.addEventListener('click', this.toggleFilterBlock.bind(this)));

    filterNodes.subCollectionLinks = Array.from(document.getElementsByClassName('subcollection-links'));
    filterNodes.subCollectionLinks.forEach(link => link.addEventListener('click', this._manageSubCollections.bind(this)));

    if(filterNodes.quickShopModal && typeof filterNodes.quickShopModal.updateEvents == 'function'){ 
      filterNodes.quickShopModal.updateEvents(); 
    }

    const applyBtn = filterNodes.parent.querySelector('[data-applyFilters]');
    if(applyBtn){
      applyBtn.addEventListener('click', () => {
        const searchParams = this._createQueryString(this.filterForm)
        this.renderPage(searchParams);
      });
    }

    const paginationLinks = document.querySelectorAll('[data-pagelinks]');
    paginationLinks.forEach(link => link.addEventListener('click', this._managePagination.bind(this)));

    this.colorOptionsStyling();
    this.bindActiveFilterButtonEvents();
  }

  /**
   * Collection filter form Input event
   * @param {event} event Event Instance
   */
  onSubmitHandler(event) {
    let isMember = document.body.getAttribute('data-customer');
    const ptFitlerCheckboxes = document.querySelectorAll('.pt-filter');
    const nonptFitlerCheckboxes = document.querySelectorAll('.non-pt-filter');

    if(ptFitlerCheckboxes.length > 0 && nonptFitlerCheckboxes.length > 0){
      const nonptFitlerCheckboxesArray = Array.from(nonptFitlerCheckboxes);
      ptFitlerCheckboxes.forEach(checkbox => {
        checkbox.checked = false;
      });
      if(isMember == 'true'){
        let getMemberFileterEle = document.querySelector(`.filter-option[data-handle="member"]`);
        if(getMemberFileterEle !== null){
          getMemberFileterEle.checked = true;
        }
        if(nonptFitlerCheckboxesArray.some(checkbox => checkbox.checked) == false){
          getMemberFileterEle.checked = false;
        }
      }else{
        let getNonMemberFileterEle = document.querySelector(`.filter-option[data-handle="non-member"]`);
        if(getNonMemberFileterEle !== null){
          getNonMemberFileterEle.checked = true;
        }
        if(nonptFitlerCheckboxesArray.some(checkbox => checkbox.checked) == false){
          getNonMemberFileterEle.checked = false;
        }
      }
    }
    
    event.preventDefault();
    if(event.type == 'input' && filterNodes.parent.classList.contains('filter-active') && filterNodes.parent.classList.contains('without-sorting')){
      return;
    }

    const searchParams = this._createQueryString(this.filterForm)
    this.renderPage(searchParams);
  }

  /**
   * click event To Remove current selections
   * @param {element} form Collection page filter form
   */
  _createQueryString(form){
    const formData = new FormData(form);
    if(form.querySelector('[name="filter.v.price.gte"]')){
      const priceGTE = form.querySelector('[name="filter.v.price.gte"]').min;
      const priceLTE = form.querySelector('[name="filter.v.price.lte"]').max;

      if(parseInt(formData.get('filter.v.price.gte')) == parseInt(priceGTE)){
        formData.delete('filter.v.price.gte');
      }
      if(parseInt(formData.get('filter.v.price.lte')) == parseInt(priceLTE)){
        formData.delete('filter.v.price.lte');
      }
    }
    return new URLSearchParams(Array.from(formData)).toString();
  }

  /**
   * 
   * @param {String} searchParams Query Parameters
   * @param {String} updateURLHash true/false
  */
  renderPage(searchParams, updateURLHash = true) {
    filterNodes.gridsContainer.classList.add('loading');

    const url = `${window.location.pathname}?${searchParams}`;
    this.renderGridFromFetch(url, 'filter');

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  /**
   * Add background color in label of Color options
   */
  colorOptionsStyling(){
    const colorSwatchContainer = filterNodes.parent.querySelector('[data-colorFilter]');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.color-options');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="checkbox"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.option-label').setAttribute('style', swatchStyle);
      });
    }
  }

  /**
   * click event To Remove current selections
   * @param {event} event Event Instance
   */
   onActiveFilterClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    let URLString = new URL(event.currentTarget.href).searchParams.toString();
    if(URLString != null) this.renderPage(URLString);
  }

   /**
   * Update Window URL as per active filters
   * @param {event} event Event Instance
   */
  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || '';
    this.renderPage(searchParams, false);
  }

  /**
   * 
   * @param {String} url URL for fetching results
   * @param {String} type filter / pagination / sub_collection
   */
  renderGridFromFetch(url, type, collectionfilter) {
    if(!url) return;

    let sectionID = document.getElementById('products-listing').dataset.id;
    let sectionQuery = sectionID;
    if(document.querySelector('[data-collectionBanner]')){
      var bannerSectionID = document.querySelector('[data-collectionBanner]').dataset.id;
    }
    if(document.querySelector('[data-top-banners]')){
      var topBannerSectionID = document.querySelector('[data-top-banners]').dataset.id;
    }
    

    if(type == 'sub_collection'){
      if(bannerSectionID){
        sectionQuery += `,${bannerSectionID}`;
      }
      if(topBannerSectionID){
        sectionQuery += `,${topBannerSectionID}`;
      }
      url += `&sections=${sectionQuery}`;
    }else{
      if(bannerSectionID){
        sectionQuery += `,${bannerSectionID}`;
      }
      if(topBannerSectionID){
        sectionQuery += `,${topBannerSectionID}`;
      }
      url += `&sections=${sectionQuery}`;
    }
   
    fetch(url)
      .then(response => response.json())
      .then((response) => {
        let gridHTML = response[sectionID];
        let bannerHTML = response[bannerSectionID];
        let topBannerHTML = response[topBannerSectionID];
        
        this.renderProductGrid(type, gridHTML, bannerHTML, topBannerHTML, collectionfilter);
        if (event && type == 'pagination') {
          event.currentTarget.classList.remove("loading");
        }
      })
      .catch(error => {
        console.error('Fetch error:', error);
      });
  }

  /**
   * 
   * @param {HTMlResponse} html 
   * @param {String} type filter / pagination / sub_collection
   */
  renderProductGrid(type, grid, banner, topBanner, collectionFilter) {
    const openFilters = document.querySelectorAll('.filter__container.open');
    const collectionParent = new DOMParser().parseFromString(grid, 'text/html');
    
    // We have used individuals components replacement code because of load more feature
    let paginationType = 'numbers';
    if(filterNodes.paginationParent){
      paginationType = filterNodes.paginationParent.dataset.type || 'numbers';
    }

    if(type == 'pagination' && paginationType == 'loadmore'){
      let productGrids = filterNodes.gridsContainer.querySelector('#product-grids');
      
      const newProductsHTML = collectionParent.getElementById('product-grids').innerHTML;
      
      productGrids.insertAdjacentHTML('beforeend', newProductsHTML);

      let showCustCount = document.querySelector('[data-show-cust-count]');
      if(showCustCount){
        let showCustCountNumber = Number(showCustCount.getAttribute('data-show-cust-count'));
        let newCountEle = collectionParent.querySelector('[data-cust-count]');
        if(newCountEle){
          let newCountEleCount = Number(newCountEle.getAttribute('data-cust-count'));
          let calculateCount = showCustCountNumber + newCountEleCount;
          let loadMoreCountEle = collectionParent.querySelector('[data-next-count]');
          showCustCount.setAttribute('data-show-cust-count',calculateCount);
          showCustCount.innerHTML = calculateCount;
          if(loadMoreCountEle){
            let loadMoreCount = loadMoreCountEle.getAttribute('data-next-count');
            document.querySelector('[data-next-count]').innerHTML = loadMoreCount;
            document.querySelector('[data-next-count]').setAttribute('data-next-count',loadMoreCount);
          }
        }
      }

      let loadMoreBtn = document.getElementById('load-more');
      let new_loadMoreBtn = collectionParent.getElementById('load-more');      

      if(new_loadMoreBtn && loadMoreBtn){   
        loadMoreBtn.parentNode.replaceChild(new_loadMoreBtn, loadMoreBtn); 
      }else if(loadMoreBtn){
        loadMoreBtn.remove();
      }
    }else{
      const gridsHTML = collectionParent.getElementById('products-listing').innerHTML;
      filterNodes.gridsContainer.innerHTML = gridsHTML;
    }
    if(collectionFilter != 'activeCollectionFilter'){
      const filterInnerHTML = collectionParent.getElementById('CollectionFiltersForm').innerHTML;
      this.filterForm.innerHTML = filterInnerHTML;
    }
    

    const activeFilters = collectionParent.querySelector('[data-activeFilters]');
    if(activeFilters) document.querySelector('[data-activeFilters]').innerHTML = activeFilters.innerHTML;
    this.dynamicEleEvents();

    /******** Change banner on subcollection **********/
    if((type == 'sub_collection' || type == 'filter') && filterNodes.collectionBanner){
      const bannerNode = new DOMParser().parseFromString(banner, 'text/html');
      let bannerHTML = bannerNode.querySelector('[data-collectionBanner]').innerHTML;
      filterNodes.collectionBanner.innerHTML = bannerHTML;

      const topbannerNode = new DOMParser().parseFromString(topBanner, 'text/html');
      if(topbannerNode && topbannerNode.querySelector('[data-top-banners]')){
        const topbannerHTML = topbannerNode.querySelector('[data-top-banners]').innerHTML;
        if(topbannerHTML){
          filterNodes.topBanners.innerHTML = topbannerHTML;
        }
      }

      
      let totalproducts = collectionParent.querySelector('[data-totalproducts]');
      if (totalproducts) {
        document.querySelector('[data-totalproducts]').innerHTML = totalproducts.innerHTML;
      }
    }

    /********  reopen filter blocks which are active before HTML update **********/
    // openFilters.forEach(openFilter => {
    //   let filterBlock = document.querySelector('.filter__container[data-index="'+openFilter.dataset.index+'"]');
    //   filterBlock.classList.add('open');
    //   filterBlock.querySelector('.filter__block')?.classList.add('open');
    // });

    /********  refresh yotpo review widget to display star rating **********/
    /* if (typeof Yotpo != 'undefined') {
      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();
    } */

    let drawerOpen = filterNodes.parent.classList.contains('filter-active');
    if(drawerOpen) filterNodes.closeDrawer.dispatchEvent(new Event('click'));
  }

  /**
   * Re-Binding events on active filters after ajax request
   */
  bindActiveFilterButtonEvents() {
    let removeActiveFilters = Array.from(document.getElementsByClassName('filter-option-clear'));
    removeActiveFilters.forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick.bind(this), { once: true });
    });
  }

  /**
   * Update the url
   * @param {String} searchParams 
   */
  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  /**
   * 
   * @param {event} event 
   */
  updateSortBy(event){
    let currentEle = event.currentTarget;
    let targetOpt = this.filterForm.querySelector(`input[name="sort_by"][value="${currentEle.value}"]`);
    if(targetOpt){
      targetOpt.checked = true;
      this.filterForm.dispatchEvent(new Event('input', {
        once: true,
      }));
    }
  }

  /**
   * 
   * @param {event} event 
   */
  paginateProductsBy(event){
    event.preventDefault();
    let currentValue = document.querySelector('[data-custom-pagination] [name="paginateBy"]:checked').value;
    let requestData = { 
      attributes: { 'products_per_page': currentValue } 
    };

    fetch("/cart/update", {
    method: "POST",
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
    },
    body: JSON.stringify(requestData),
    }).then((data) =>{
      const searchParams = this._createQueryString(this.filterForm);
      const url = `${window.location.pathname}?${searchParams}`;
      this.renderGridFromFetch(url, 'pagination');
    });
  }

  /**
   * 
   * @param {event} event 
   */
  _manageSubCollections(event){
    event.preventDefault();
    const _this =  event.currentTarget;
    const queryString = this._createQueryString(this.filterForm);
    let collURL = _this.href + '?' + queryString;
  
    if(_this.classList.contains('tab_toggle') && _this.classList.contains('active') ){
      // this.renderGridFromFetch(collURL, 'sub_collection', 'activeCollectionFilter');
    }else{
      this.renderGridFromFetch(collURL, 'sub_collection');
      setTimeout(() => {
        filterNodes.subCollectionLinks.forEach(link => link.classList.remove('active'));
        _this.classList.add('active');
        history.pushState({}, '', collURL);
      }, 500);
    }

  }

  /**
   * 
   * @param {event} event 
   */
  _managePagination(event){
    event.preventDefault();
    let _this = event.currentTarget;
    
    let paginationType = _this.closest('[data-paginationparent]').dataset.type;
    
    this.renderGridFromFetch(_this.href, 'pagination');

    if (paginationType == 'loadmore' && event) {
      event.currentTarget.classList.add("loading");
    }
    
    if(paginationType != 'loadmore'){
      setTimeout(() => {
        history.pushState({}, '', _this.href);
      }, 500);
    }
  }

  /**
   * Toggle Filter drawer
   * @param {event} event 
   */
  toggleFilterDrawer(event){
    event.preventDefault();
    let button = event.currentTarget;
    if(button.id == 'filter-drawer'){
      button.setAttribute('aria-expanded', true);
      button.setAttribute('tabindex', '-1');

      filterNodes.parent.classList.add('filter-active', 'without-sorting');

      setTimeout(() => {
        filterNodes.parent.classList.add('slide-from-right');
      }, 100);

      Utility.trapFocus(filterNodes.parent);
      Utility.forceFocus(filterNodes.closeDrawer);
      siteOverlay.prototype.showOverlay();
    }else if (button.id == 'sort-drawer') {
      button.setAttribute('aria-expanded', true);
      button.setAttribute('tabindex', '-1');

      filterNodes.parent.classList.add('filter-active', 'with-sorting');

      setTimeout(() => {
        filterNodes.parent.classList.add('slide-from-bottom');
        filterNodes.parent.querySelector('.custom-dropdown-sortByMobile')?.classList.add('open');
        filterNodes.parent.querySelector('[data-sortByMobile]')?.classList.add('open');
      }, 100);

      Utility.trapFocus(filterNodes.parent);
      Utility.forceFocus(filterNodes.closeDrawer);
      siteOverlay.prototype.showOverlay();
    }else{
      filterNodes.parent.classList.remove('slide-from-right', 'slide-from-bottom');
      setTimeout(() => {
        filterNodes.parent.classList.remove('filter-active', 'with-sorting', 'without-sorting');
      }, 300);
      if(this.openFilterDrawer){
        this.openFilterDrawer.setAttribute('aria-expanded', false);
        this.openFilterDrawer.removeAttribute('tabindex');
      }
      if(this.openSortbyDrawer){
        this.openSortbyDrawer.setAttribute('aria-expanded', false);
        this.openSortbyDrawer.removeAttribute('tabindex');
      }

      Utility.removeTrapFocus(filterNodes.parent);
      siteOverlay.prototype.hideOverlay();
    }
  }

  /**
   * Toggle Filter drawer
   * @param {event} event 
  */
  toggleFilterBlock(event) {
    event.preventDefault();
    const toggleFilterBtn = event.currentTarget;
    const filterContainer = toggleFilterBtn.closest('.filter__container');
    const isOpen = filterContainer?.classList.contains('open');
    
    if(filterContainer.classList.contains('collaspible_coll')){
      if(filterContainer.querySelector('.subcollection-links').classList.contains('active')){
        isOpen ? this.closeFilterBlock(toggleFilterBtn) : this.openFilterBlock(toggleFilterBtn);
      }
    }else{
      isOpen ? this.closeFilterBlock(toggleFilterBtn) : this.openFilterBlock(toggleFilterBtn);
    }
  }

  /**
   * Open Filter Block
   * @param {element} toggleFilterBtn 
   */
  openFilterBlock(toggleFilterBtn){
    let filterContainer = toggleFilterBtn.closest('.filter__container');
    toggleFilterBtn.setAttribute('aria-expanded', true);
    Utility.toggleElement(filterContainer, 'open');
    Utility.trapFocus(filterContainer);
  }

  /**
   * Close Filter Block
   * @param {element} toggleFilterBtn 
   */
  closeFilterBlock(toggleFilterBtn){
    const filterContainer = toggleFilterBtn.closest('.filter__container');
    toggleFilterBtn.setAttribute('aria-expanded', false);
    Utility.toggleElement(filterContainer, 'close');
    Utility.removeTrapFocus(filterContainer);
  }

  /**
   * Trigger 'Featured' sort option on page load
   */
  triggerFeaturedSortOnLoad() {
    // Find the Featured sort option
    const featuredSortInput = this.filterForm?.querySelector('input[name="sort_by"][value="manual"]');
    if (featuredSortInput) {
      featuredSortInput.checked = true;
      featuredSortInput.dispatchEvent(new Event('change'));

      this.filterForm.dispatchEvent(new Event('input', {
        once: true,
      }));
    }
  }
}
typeof CollectionFilters !== 'undefined' && new CollectionFilters();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  /**
   * 
   * @param {event} event 
   */
  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);

class PriceRangeSlider extends HTMLElement {
  constructor() {
    super();

    let _this = this;
    let sliderSections = this.getElementsByClassName("range-slider");
    
    for(const element of sliderSections){
      let sliders = element.getElementsByTagName("input");
      for(const element of sliders){
        if(element.type ==="range" ){
          element.oninput = _this.getVals;
          element.oninput();
        }
      }
    }
  }
  
  // Get Price value from both range slider
  getVals(){
    let parent = this.parentNode;
    let slides = parent.getElementsByTagName("input");
    let slide1 = parseFloat(slides[0].value);
    let slide2 = parseFloat(slides[1].value);
      
    // Neither slider will clip the other, so make sure we determine which is larger
    if( slide1 > slide2 ){ let tmp = slide2; slide2 = slide1; slide1 = tmp; }
    
    let displayElement = parent.getElementsByClassName("rangeValues")[0];
    displayElement.innerHTML = Utility.formatMoney((slide1*100), window.globalVariables.money_format)+ ' - ' + Utility.formatMoney((slide2*100), window.globalVariables.money_format);
  }
}
customElements.define('range-slider', PriceRangeSlider);


/***
 ***** Collection join Save btn js
***/

let joinUsBtn = document.querySelector('[data-join-save="open"]');
let closeJoinUs = document.querySelector('[data-join-save="close"]');
let joinSaveWrapper = document.querySelector('.collection-banner-bottom-join-save-wrapper');
if (joinUsBtn && joinSaveWrapper) {
  joinUsBtn.addEventListener('click', handleJoinUs);
}
if (closeJoinUs && joinSaveWrapper) {
  closeJoinUs.addEventListener('click', handleJoinUs);
}

function handleJoinUs (event) {
  if (event.currentTarget.dataset.joinSave == 'open') {
    joinSaveWrapper?.classList.add('open');
    if(window.innerWidth < 768){
      siteOverlay.prototype.showOverlay();
    }
    setTimeout(() => {
      event.target.closest('.colection-banner-section')?.classList.remove('overflow-hidden');
    }, 400);
  } else if (event.currentTarget.dataset.joinSave == 'close') {
    joinSaveWrapper?.classList.remove('open');
    siteOverlay.prototype.hideOverlay();
    event.target.closest('.colection-banner-section')?.classList.add('overflow-hidden');
  }
}

/***
 ***** Collection join Save btn js END
***/